import { useEffect, useState } from "react";
import { Report } from "src/Interfaces/TableInterfaces";
import { packetErrorHandler } from "src/Utils/requestUtils";

type GetErrorsTableFn = (
  searchParam: any,
  offset: number | null,
  pageSize: number | null
) => Promise<Report<any>>;

export function useErrorTabCount(
  storageKeyPrefix: string,
  activeTabIndex: number,
  errorsTabIndex: number,
  getErrorsTable: GetErrorsTableFn,
  searchParam: any = {}
) {
  const [errorTableRefreshFlag, setErrorTableRefreshFlag] = useState(false);

  const [errorCount, setErrorCountState] = useState(() =>
    parseInt(localStorage.getItem(`${storageKeyPrefix}ErrorCount`) || "0")
  );

  const [seenErrorCount, setSeenErrorCountState] = useState(() => {
    const error = parseInt(
      localStorage.getItem(`${storageKeyPrefix}ErrorCount`) || "0"
    );
    const seen = parseInt(
      localStorage.getItem(`${storageKeyPrefix}SeenErrorCount`) || "0"
    );
    return Math.min(seen, error);
  });

  const setErrorCount = (count: number) => {
    localStorage.setItem(`${storageKeyPrefix}ErrorCount`, count.toString());
    setErrorCountState(count);

    const seen = parseInt(
      localStorage.getItem(`${storageKeyPrefix}SeenErrorCount`) || "0"
    );
    if (count < seen) {
      localStorage.setItem(`${storageKeyPrefix}SeenErrorCount`, count.toString());
      setSeenErrorCountState(count);
    }
  };

  const setSeenErrorCount = (count: number) => {
    localStorage.setItem(`${storageKeyPrefix}SeenErrorCount`, count.toString());
    setSeenErrorCountState(count);
  };

  useEffect(() => {
    function fetchErrorsTable() {
      const today = new Date().toISOString().split("T")[0];
      const errorDate = localStorage.getItem(`${storageKeyPrefix}ErrorDate`);

      if (errorDate && errorDate !== today) {
        localStorage.removeItem(`${storageKeyPrefix}ErrorCount`);
        localStorage.removeItem(`${storageKeyPrefix}SeenErrorCount`);
      }
      if (activeTabIndex === errorsTabIndex) setErrorTableRefreshFlag(true);

      getErrorsTable(searchParam, 0, 50)
        .then((res) => {
          const errors = res.count || 0;
          setErrorCount(errors);
          if (activeTabIndex === errorsTabIndex) setSeenErrorCount(errors);

          localStorage.setItem(`${storageKeyPrefix}ErrorDate`, today);
        })
        .catch(packetErrorHandler);
    }

    const interval = setInterval(() => {
      fetchErrorsTable();
    }, 10000);
    return () => clearInterval(interval);
  }, [activeTabIndex]);

  const errorTableAfterFetchHandler = () => {
    setSeenErrorCount(errorCount);
    setErrorTableRefreshFlag(false);
  };

  return {
    errorTabCount: errorCount - seenErrorCount,
    errorTableRefreshFlag,
    errorTableAfterFetchHandler,
  };
}
